import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Calendar } from "lucide-react";
import PageHero from "@/components/shared/PageHero";
import api from "@/lib/api";

export default function Blogs() {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => { api.get("/blogs").then((r) => setBlogs(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHero
        label="Journal"
        title="Insights, trends, and business intelligence."
        subtitle="Actionable content for retailers, distributors, and boutique owners — from wholesale garment trends to industry updates."
        breadcrumbs={[{ label: "Blogs" }]}
      />
      <section className="py-14">
        <div className="mx-auto max-w-7xl px-4 md:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogs.map((b, i) => (
            <motion.div key={b.id} initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.05 }}>
              <Link to={`/blogs/${b.slug}`} className="group block h-full border border-border/60 hover:border-gold/60 rounded-md overflow-hidden bg-card transition-colors">
                {b.cover_image && (
                  <div className="aspect-[16/10] overflow-hidden bg-secondary">
                    <img src={b.cover_image} alt={b.title} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" />
                  </div>
                )}
                <div className="p-6">
                  <p className="section-label mb-3 flex items-center gap-2"><Calendar size={12} />{new Date(b.publish_date).toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" })}</p>
                  <h3 className="font-serif text-2xl text-foreground group-hover:text-gold transition-colors leading-tight">{b.title}</h3>
                  <p className="mt-3 text-sm text-foreground/70 line-clamp-3">{b.excerpt}</p>
                  <p className="mt-5 text-xs tracking-wider uppercase text-gold flex items-center gap-1">Read Article <ArrowRight size={12} className="transition-transform group-hover:translate-x-1" /></p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
